import { LifeLabs01 } from 'ethena-icons';
import { SVGProps } from 'react';

export const LifeLabsIcon = ({
  width = 16,
  height = 16,
  ...rest
}: SVGProps<SVGSVGElement>) => (
  <LifeLabs01 color="#E03B63" height={height} width={width} {...rest} />
);
